import { CreateQuoteInput } from '__generated__/GQL';
import { QUOTE_VALIDITY_DAYS_UNLIMITED } from 'features/Work/constants';
import { QuoteFormSchema } from 'features/Work/form/quoteForm.schema';
import { formatInvoiceTask } from 'features/Work/utils/formatInvoiceTask';

export const formatCreateMutationInput = (
  quote: QuoteFormSchema,
): CreateQuoteInput => {
  const sortedTasksWithoutTotals = quote.tasks.map(formatInvoiceTask);

  return {
    clientId: quote.clientId,
    companyProfileId: quote.companyProfileId,
    fiscalId: quote.fiscalId,
    lateFeePercentage: quote.lateFeePercentage,
    lateMaxDays: quote.lateMaxDays,
    settings: {
      displayTradeName: quote.settings.displayTradeName,
      issuerEmail: quote.settings.issuerEmail,
      legalMentions: quote.settings.legalMentions,
      quoteValidityDays:
        quote.settings.quoteValidityDays ?? QUOTE_VALIDITY_DAYS_UNLIMITED,
    },
    startAt: quote.startAt,
    subtitle: quote.subtitle,
    tasks: sortedTasksWithoutTotals,
    title: quote.title,
  };
};
